import type { GemsApi_StoneShape, StoneShapeCode } from '@/graphql/api'
import type { Icons } from '@/components/ui/icon'
import { lowercase } from '@/helpers/string-case'

import type { AllowedStoneShape } from '@/domain/stone/search/allowed-shapes.ts'

export function getShapeIcon(shape: AllowedStoneShape): Icons {
    return `shape-${lowercase(shape)}`
}

/** @ts-expect-error alabala https://taylorandhart.atlassian.net/browse/TH-9299 */
const mappingGemsApiShapeToIcon: Record<
    GemsApi_StoneShape,
    AllowedStoneShape | undefined
> = {
    ASSCHER: 'ASSCHER',
    CABOCHON: undefined,
    CIRCULAR: undefined,
    CUSHION: 'CUSHION',
    EMERALD: 'EMERALD',
    EUROPEAN: undefined,
    HALF_MOON: undefined,
    HEART: 'HEART',
    HEXAGONAL: 'HEXAGONAL',
    MARQUISE: 'MARQUISE',
    OCTAGONAL: undefined,
    OLD_MINERS: undefined,
    OVAL: 'OVAL',
    PEAR: 'PEAR',
    PRINCESS: 'PRINCESS',
    RADIANT: 'RADIANT',
    ROSE: undefined,
    ROUND: 'ROUND',
    STRAIGHT_BAGUETTE: undefined,
    TAPERED_BAGUETTE: undefined,
    TRAPEZOID: undefined,
    TRIANGULAR: undefined,
}

export function getGemsApiShapeIcon(
    shape: GemsApi_StoneShape
): Icons | undefined {
    const mappedShape = mappingGemsApiShapeToIcon[shape]

    if (mappedShape !== undefined) {
        return getShapeIcon(mappedShape)
    }

    return undefined
}

const mappingMonolithShapeCodeToIcon: Record<
    StoneShapeCode,
    AllowedStoneShape | undefined
> = {
    ASSCHER: 'ASSCHER',
    CABOCHON: undefined,
    CIRCULAR: undefined,
    CUSHION: 'CUSHION',
    EMERALD: 'EMERALD',
    EUROPEAN: undefined,
    HALF_MOON: undefined,
    HEART: 'HEART',
    HEXAGONAL: 'HEXAGONAL',
    MARQUISE: 'MARQUISE',
    OCTAGONAL: undefined,
    OLD_MINERS: undefined,
    OVAL: 'OVAL',
    PEAR: 'PEAR',
    PRINCESS: 'PRINCESS',
    RADIANT: 'RADIANT',
    ROSE: undefined,
    ROUND: 'ROUND',
    STRAIGHT_BAGUETTE: undefined,
    TAPERED_BAGUETTE: undefined,
    TRAPEZOID: undefined,
    TRIANGULAR: undefined,
    BRILLIANT_CUT_TRAPEZOID: undefined,
    BULLET: undefined,
    CARRE: undefined,
    CUSTOM: undefined,
    KITE: undefined,
    RECTANGULAR_FRENCH: undefined,
    SQUARE_FRENCH: undefined,
    STEP_CUT_TRAPEZOID: undefined,
    TRILLION: undefined,
}

export function getMonolithShapeIcon(shape: StoneShapeCode): Icons | undefined {
    const mappedShape = mappingMonolithShapeCodeToIcon[shape]

    if (mappedShape !== undefined) {
        return getShapeIcon(mappedShape)
    }

    return undefined
}
